export default __webpack_public_path__ + "images/2f76b4b29f6a993f390d1c0a5ba44ded.png";